import * as React from 'react';
import { forwardRef } from 'react';
const CheckOutline = (props, ref) => {
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("path", { d: "M11.903 6.238a.75.75 0 1 0-1.14-.976L7.292 9.314 5.197 7.22a.75.75 0 0 0-1.06 1.06l2.666 2.667a.75.75 0 0 0 1.1-.042l4-4.667Z", fill: "var(--mollie-ui-icon-fill, currentColor)" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z", fill: "var(--mollie-ui-icon-fill, currentColor)" })));
};
const ForwardRef = forwardRef(CheckOutline);
export default ForwardRef;
ForwardRef.displayName = 'CheckOutline';
//# sourceMappingURL=CheckOutline.js.map